/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect, useMemo } from 'react'
import MovingIcon from '@mui/icons-material/Moving';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';

// @components
import {
  Grid,
  Box,
  Collapse,
} from '../../../components/shared/MaterialUI'

// @assets
import { StatsStyles } from '../../../assets/css/statsBoxes-style'

// @components
import StatsBoxCard from '../../../components/atoms/StatsBoxCard';
import useAdmin from '../hooks/UseAdmin';

const ToggleCollapse = ({ isContainerOpen }) => {
  const statsStyles = useMemo(() => StatsStyles(), []);
  const { getStatsToggle, statsToggle } = useAdmin();

  useEffect(() => {
    if(isContainerOpen) getStatsToggle();
  }, [isContainerOpen]);

  return (
    <Collapse in={isContainerOpen}>
      <Box sx={{marginTop: '15px' }}>
        <Grid
          component={'section'}
          sx={statsStyles.container}
        >
          <StatsBoxCard
            title='Monthly growth'
            iconStats={<MovingIcon sx={statsStyles.icon} />}
            value={`+${statsToggle?.employers} employers`}
            hasButton={false}
            hasFooterText={`+${statsToggle?.employees} new employees this month`}
          />

          <StatsBoxCard
            title='Pending actions'
            iconStats={<WarningAmberIcon sx={statsStyles.icon} />}
            value={`${statsToggle?.missingEmployeeData} employers`}
            hasButton={false}
            hasFooterText={'Missing employee data'}
          />
          
          <StatsBoxCard
            title='Last month'
            iconStats={<FormatListNumberedOutlinedIcon sx={statsStyles.icon} />}
            value={`${statsToggle?.completedSurveys} employees`}
            hasButton={false}
            hasFooterText={'Completed questionnaires'}
          />
        </Grid>
      </Box>
    </Collapse>
  )
}

export default ToggleCollapse